import { WindowRefService } from "./services/window-ref.service";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AppComponent } from "./app.component";
import { EngineComponent } from "./components/engine/engine.component";
import { UiComponent } from "./ui/ui.component";
import { MenuComponent } from "./ui/menu/menu.component";
import { MenuItemComponent } from "./ui/menu/menu-item/menu-item.component";
import { ButtonComponent } from "./ui/buttons/button/button.component";
import { HttpClientModule } from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
import { SafeURLPipe } from "./pipes/safe-url.pipe";
//import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FloatingMenuComponent } from './ui/floating-menu/floating-menu.component';
import { FloatingMenuButtonComponent } from './ui/floating-menu-button/floating-menu-button.component';

@NgModule({
  declarations: [
    AppComponent,
    EngineComponent,
    UiComponent,
    MenuComponent,
    MenuItemComponent,
    ButtonComponent,
    SafeURLPipe,
    FloatingMenuComponent,
    FloatingMenuButtonComponent,
  ],
  imports: [BrowserModule, FormsModule, AppRoutingModule, HttpClientModule, /*ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })*/],
  providers: [WindowRefService],
  bootstrap: [AppComponent],
})
export class AppModule {}
